import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import ModalComponent from "../../../Components/Modais";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import Table from "../../../Components/Table";
import OrSpinner from "../../../Components/Utils/OrSpinner";
import { ListarEquipesDeVendasController } from "../../../Controllers/Vendas/EquipeVendas/EquipeVendasControllers";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import usePaginationFilter from "../../../hooks/usePaginationFilter";
import { IGestaoProdutosVinculados } from "../../../Interfaces/Vendas/GestaoProdutoVinculados/GestaoProdutosVinculadosInterface";
import VincularProdutosEquipeVenda from "./VincularProdutosEquipeVenda";

export default function GestaoVistoriaEquipeProduto() {
    const { PageFilter, setPage } = usePaginationFilter({ page: 1 });
    const [show, SetShow] = useState(false);
    const [Modal, SetModal] = useState<IComponentModal>();

    const {
        value: listarTiposEquipeVendas,
        loading: listarTiposEquipeVendasLoading,
    } = useAsyncEffect(() => ListarEquipesDeVendasController(), [PageFilter]);

    //Tabela
    const columns: Array<ColumnDescription<IGestaoProdutosVinculados>> = [
        {
            dataField: "DS_NOME_EQUIPE",
            text: "Nome",
            formatter: rowTipoDocumentoEtapa,
            sort: true,
        },
        {
            dataField: "button",
            text: "",
            isDummyField: true,
            formatter: (_, row) => (
                <div className="Button-Tools">
                    <button
                        className="btn btn-outline-primary font-weight-bold mr-2"
                        type="submit"
                        onClick={() => {
                            SetShow(true);
                            SetModal({
                                headerComponent: "VINCULO DOS PRODUTOS",
                                Component: () => (
                                    <VincularProdutosEquipeVenda
                                        idEquipeVendas={row.ID_EQUIPE_VENDAS}
                                        idProduto={row.ID_PRODUTO}
                                    />
                                ),
                                size: "xl",
                            });
                        }}
                    >
                        <FontAwesomeIcon icon={faEdit} size="lg" /> Editar
                    </button>
                </div>
            ),
        },
    ];

    function rowTipoDocumentoEtapa(
        cell: string,
        row: IGestaoProdutosVinculados
    ) {
        return (
            <div className="rowCapysTCA d-flex justify-content-center align-items-center mr-5">
                <div>
                    <label className="mb-1">{row.DS_EQUIPE_VENDAS}</label>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className="card">
                <div className="card-header">
                    <h2 className="mb-0">Vincular Produtos</h2>
                </div>
                <div className="card-body">
                    <div className="col-12 mt-5">
                        <OrSpinner
                            loading={listarTiposEquipeVendasLoading}
                            spinner="capys"
                        >
                            <Table
                                keyField="ID_TIPO_DOCUMENTO_ETAPA_TIPO_CASO"
                                columns={columns}
                                data={listarTiposEquipeVendas ?? []}
                                sizePerPage={10}
                                loading={listarTiposEquipeVendasLoading}
                                noDataIndication={
                                    <div className="text-center text-muted">
                                        Nenhuma etapa
                                    </div>
                                }
                                onTableChange={(type, newState) => {
                                    setPage(newState.page);
                                }}
                                wrapperClasses="wrapperTable mw-100 x-scroll"
                                classes="tableClasses"
                                bordered={false}
                                center
                                defaultStyle={{
                                    align: "center",
                                    classes: "p-2",
                                }}
                            />
                        </OrSpinner>
                    </div>
                </div>

                <ModalComponent
                    show={show}
                    setShow={SetShow}
                    ModalComponent={Modal}
                />
            </div>
        </>
    );
}
